import {IconArrowBack, MarketplaceLogo, Text} from '@treatwell/ui';
import {useTranslation} from 'react-i18next';
import styles from './AuthHeader.module.css';

const handleBack = () => {
  if (window.history.length > 1) {
    window.history.back();
  } else {
    window.location.assign('/');
  }
};

export const AuthHeader = () => {
  const {t} = useTranslation();
  const backLabel = t('headerNavigation.back');

  return (
    <header className={styles.header}>
      <button
        type="button"
        aria-label={backLabel}
        data-cy="BackButton"
        className={styles.back}
        onClick={handleBack}
      >
        <IconArrowBack size={24} />
        <Text type="bodyHeavy" className={styles.backLabel}>
          {backLabel}
        </Text>
      </button>
      <a href="/" aria-label="Treatwell" className={styles.logoLink}>
        <MarketplaceLogo className={styles.logo} />
      </a>
    </header>
  );
};
